import { render } from "./DuelsReel.vue?vue&type=template&id=5365d7ca"
import script from "./DuelsReel.vue?vue&type=script&lang=js"
export * from "./DuelsReel.vue?vue&type=script&lang=js"

import "./DuelsReel.vue?vue&type=style&index=0&id=5365d7ca&scope=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__